export const workspace = {
  routes: [
    {
      path: "/workspace/library/source-and-type",
      component: () => import("../workspace-library-source-and-type-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/source-and-type",
      component: () => import("../management-library-source-and-type-view"),
    },
  ],
};
